export default __webpack_public_path__ + "static/media/Hair_13.fd769584.svg";